"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.upload.mode.title': 'Elegir Método de Entrada de Datos',
    'trainer.upload.mode.file': 'Subir Archivo CSV',
    'trainer.upload.mode.manual': 'Entrada Manual',
    'trainer.upload.mode.pdf': 'Procesamiento de PDF',
    'trainer.upload.mode.file.description': 'Subir un archivo CSV preformateado con sus datos de entrenamiento',
    'trainer.upload.mode.manual.description': 'Crear datos de entrenamiento usando una interfaz de formulario fácil de usar',
    'trainer.upload.mode.pdf.description': 'Subir un PDF para extraer automáticamente y generar datos de entrenamiento desde los capítulos',
    'trainer.upload.title': 'Subir Datos de Entrenamiento (CSV)',
    'trainer.upload.format.required': 'Formato CSV Requerido:',
    'trainer.upload.format.input': 'El texto de pregunta/prompt',
    'trainer.upload.format.output': 'La respuesta/salida esperada',
    'trainer.upload.format.category': 'Categoría de clasificación',
    'trainer.upload.format.optional': 'opcional',
    'trainer.upload.format.metadata': 'Se admiten columnas de metadatos adicionales y se conservarán.',
    'trainer.upload.processing': 'Procesando archivo...',
    'trainer.upload.select': 'Seleccionar Archivo CSV',
    'trainer.upload.file.info': 'Información del Archivo',
    'trainer.upload.file.name': 'Nombre del archivo:',
    'trainer.upload.file.size': 'Tamaño:',
    'trainer.upload.file.type': 'Tipo:',
    'trainer.upload.data.analysis': 'Análisis de Datos',
    'trainer.upload.stats.samples': 'Muestras de Entrenamiento',
    'trainer.upload.stats.input.length': 'Longitud Promedio de Entrada',
    'trainer.upload.stats.output.length': 'Longitud Promedio de Salida',
    'trainer.upload.stats.categories': 'Categorías',
    'trainer.upload.stats.quality': 'Puntuación de Calidad',
    'trainer.upload.categories.found': 'Categorías encontradas:',
    'trainer.upload.preview': 'Vista Previa de Datos (Primeras 3 filas)',
    'trainer.upload.preview.input': 'Entrada',
    'trainer.upload.preview.output': 'Salida',
    'trainer.upload.preview.category': 'Categoría',
    'trainer.upload.manual.title': 'Crear Datos de Entrenamiento Manualmente',
    'trainer.upload.manual.description': 'Agregue ejemplos de entrenamiento uno por uno usando el formulario a continuación. Cada ejemplo debe contener un prompt de entrada y la respuesta de salida esperada.',
    'trainer.upload.manual.input': 'Entrada (Prompt)',
    'trainer.upload.manual.input.placeholder': 'Ingrese el prompt o pregunta...',
    'trainer.upload.manual.output': 'Salida (Respuesta)',
    'trainer.upload.manual.output.placeholder': 'Ingrese la respuesta esperada...',
    'trainer.upload.manual.category': 'Categoría (Opcional)',
    'trainer.upload.manual.category.placeholder': 'Ingrese una etiqueta de categoría...',
    'trainer.upload.manual.add': 'Agregar Entrada',
    'trainer.upload.manual.update': 'Actualizar Entrada',
    'trainer.upload.manual.cancel': 'Cancelar Edición',
    'trainer.upload.manual.edit': 'Editar',
    'trainer.upload.manual.delete': 'Eliminar',
    'trainer.upload.manual.list.title': 'Entradas de Datos de Entrenamiento',
    'trainer.upload.manual.export': 'Exportar como CSV',
    'trainer.upload.manual.validation.required': 'Los campos de entrada y salida son obligatorios',
    'trainer.upload.manual.export.empty': 'No hay datos de entrenamiento para exportar',
    'trainer.upload.pdf.title': 'Generación de Datos de Entrenamiento PDF',
    'trainer.upload.pdf.description': 'Subir un documento PDF para extraer automáticamente el texto y generar datos de entrenamiento organizados por capítulos.',
    'trainer.upload.pdf.upload.title': 'Subir Documento PDF',
    'trainer.upload.pdf.select': 'Seleccionar Archivo PDF',
    'trainer.upload.pdf.processing': 'Procesando PDF...',
    'trainer.upload.pdf.extracting': 'Extrayendo capítulos...',
    'trainer.upload.pdf.context.label': 'Contexto (Opcional)',
    'trainer.upload.pdf.context.placeholder': 'Proporcionar contexto adicional sobre el contenido del documento para mejorar la calidad de los datos de entrenamiento...',
    'trainer.upload.pdf.extract.button': 'Extraer Capítulos',
    'trainer.upload.pdf.chapters.title': 'Capítulos Extraídos',
    'trainer.upload.pdf.chapters.select': 'Seleccionar capítulos a procesar:',
    'trainer.upload.pdf.chapters.selectall': 'Seleccionar Todo',
    'trainer.upload.pdf.chapters.deselectall': 'Deseleccionar Todo',
    'trainer.upload.pdf.chapters.generate.button': 'Generar Datos de Entrenamiento desde Capítulos Seleccionados',
    'trainer.upload.pdf.chapters.generating': 'Generando datos de entrenamiento...',
    'trainer.upload.pdf.chapters.preview': 'Vista Previa:',
    'trainer.upload.pdf.chapters.words': 'palabras',
    'trainer.upload.pdf.file.info': 'Información del PDF',
    'trainer.upload.pdf.file.name': 'Nombre del archivo:',
    'trainer.upload.pdf.file.size': 'Tamaño:',
    'trainer.upload.pdf.file.pages': 'Páginas:',
    'trainer.upload.pdf.success': '¡Datos de entrenamiento generados exitosamente!',
    'trainer.upload.pdf.error': 'Error al procesar PDF. Por favor, inténtelo de nuevo.',
    'trainer.upload.pdf.error.extraction': 'Error al extraer capítulos del PDF',
    'trainer.upload.pdf.error.generation': 'Error al generar datos de entrenamiento',
    'trainer.upload.pdf.error.nofile': 'Por favor, seleccione un archivo PDF',
    'trainer.upload.pdf.error.nochapters': 'Por favor, seleccione al menos un capítulo',
};
